export const ProgramStatType = {
  MEMBER_COUNT: "memberCount",
  DEVICE_CONNECTED_COUNT: "deviceConnectedCount",
  AGGREGATE_DATA_TODAY: "aggregateDataToday",
  TOTAL_STEPS_ALL_TIME: "totalStepsAllTime",
  TOTAL_TEAMS: "totalTeams",
  AGGREGATE_DATA_ALL_TIME: "aggregateDataAllTime",
  AGGREGATE_DATA_AVG_DAILY: "aggregateDataAvgDaily",
  MILES_WALKED_ALL_TIME: "milesWalkedAllTime",
  CHALLENGES_TOTAL_ALL_TIME: "challengesTotalAllTime",
  CHALLENGES_TOTAL_STEPS_ALL_TIME: "challengesTotalStepsAllTime",
  AGGREGATE_ENTRIES_ALL_TIME: "aggregateEntriesAllTime",
  PHOTO_JOURNAL_ENTRIES_ALL_TIME: "photoJournalEntriesAllTime",
  WELLNESS_ENTRIES_ALL_TIME: "wellnessEntriesAllTime"
};
